module.exports = __webpack_public_path__ + "static/4_1-mnist-9fe2c1b5d633ca5e9d592a0e0b8262d4.svg";